<template>
  <div id="nav">
    <template v-if="currentUser">
      <router-link to="/clients">Clients</router-link>
      <router-link to="/tests">Tests</router-link>
      <router-link to="/account">Account</router-link>
    </template>
    <div id="nav-right">
      <UserSignin />
      <div id="admin-menu" v-if="currentUser">
        <button @click="showAdmin = !showAdmin" class="outline thin">
          <v-icon name="cog" />
        </button>
        <div v-if="showAdmin" id="admin-menu-dropdown">
          <router-link
            tag="button"
            to="/admin/markers"
            @click.native="showAdmin = false"
            >Markers</router-link
          >
          <router-link
            tag="button"
            to="/admin/kits"
            @click.native="showAdmin = false"
            >Kits</router-link
          >
          <router-link
            tag="button"
            to="/admin/lab"
            @click.native="showAdmin = false"
            >Lab</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserSignin from "@/components/UserSignin";

export default {
  data() {
    return {
      showAdmin: false
    };
  },
  components: {
    UserSignin
  }
};
</script>

<style lang="less" scoped>
@import "../styles/vars";
#nav {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  height: @h6;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  & > a {
    padding: @h1 @h2;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  & > #nav-right {
    margin-right: 0;
    padding-right: @h1;
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    #admin-menu {
      position: relative;
      #admin-menu-dropdown {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        background-color: #fff;
        position: absolute;
        top: @h4;
        right: 0;
        button {
          height: @h4;
          min-width: 200px;
          justify-content: flex-start;
          width: 100%;
          border-radius: 0;
          background-color: transparent;
          & + button {
            border-top: 1px solid #eee;
          }
          &:hover {
            background-color: #eee;
          }
        }
      }
    }
  }
  a {
    &.router-link-active {
      background-color: #333;
      color: #fff;
    }
  }
}
</style>
